import { render, staticRenderFns } from "./MentorModulesView.vue?vue&type=template&id=9e1d3a9a&"
import script from "./MentorModulesView.vue?vue&type=script&lang=js&"
export * from "./MentorModulesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports